import React from 'react';
import MemberNameLink from '../../common/MemberNameLink';

function StoryHeader({ author, createdAt, location, privacy }) {
  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown date';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="story-header">
      <div className="story-header-left">
        <div className="author-avatar">
          <span className="author-emoji">{author.emoji || '👨‍👩‍👦'}</span>
        </div>
        <div className="author-info">
          <div className="author-name"><MemberNameLink memberId={author.id} name={author.name} /></div>
          <div className="story-meta-info">
            {formatDate(createdAt)}
            {location && (
              <>
                <span className="meta-separator"> · </span>
                {location}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="story-header-right">
        <div className="legacy-badge">
          <span>🏆</span> Family Memory
        </div>
      </div>
    </div>
  );
}

export default StoryHeader;
